module.exports = __webpack_public_path__ + "img/il.e5bf7083.svg";